/**
 * Maps a prescription_catalog `internal_drug_id` to the manufacturer's
 * patient-facing product page and the brand-specific anchor text we show
 * inline (e.g. `visit ${label}.`).
 *
 * Mapping (by `internal_drug_id` prefix):
 *  - `foundayo*` → LillyDirect (Foundayo)
 *  - `zepbound*` → LillyDirect (Zepbound — KwikPen and Single-Use Vial)
 *  - `wegovy*`   → NovoCare    (Wegovy — Pill and Pen)
 *
 * Returns `null` when no mapping is known so callers can fall back to
 * non-link copy.
 */

const FOUNDAYO_URL = "https://www.lilly.com/lillydirect/medicines/foundayo";
const ZEPBOUND_URL = "https://www.lilly.com/lillydirect/medicines/zepbound";
const WEGOVY_URL = "https://www.novocare.com/patient/medicines/wegovy.html";

const LILLYDIRECT_LABEL = "the LillyDirect website";
const NOVOCARE_LABEL = "the NovoCare website";

export type ManufacturerWebsiteLink = {
  url: string;
  /**
   * Brand-specific anchor text. Includes the leading "the" so callers can drop
   * it directly into surrounding copy (e.g. `visit ${label}.`) without
   * stitching strings together.
   */
  label: string;
};

export const getManufacturerWebsiteLink = (
  internalDrugId: string | null | undefined
): ManufacturerWebsiteLink | null => {
  if (!internalDrugId) return null;
  const id = internalDrugId.toLowerCase();
  if (id.startsWith("foundayo")) {
    return { url: FOUNDAYO_URL, label: LILLYDIRECT_LABEL };
  }
  if (id.startsWith("zepbound")) {
    return { url: ZEPBOUND_URL, label: LILLYDIRECT_LABEL };
  }
  if (id.startsWith("wegovy")) {
    return { url: WEGOVY_URL, label: NOVOCARE_LABEL };
  }
  return null;
};
